import React from 'react';
import {Icon, reactCreateMemo } from '@wix/devzai-utils-react';
import IconChevronDown
    from '../../doppe-action-button-templates/doppe-standard-action-button-template/icons/ChevronDown.svg';
import {classes, style} from './doppe-payment-element-dummy.st.css';
import {DoppeActionWidgetTextBox} from '../../doppe-action-widget-text-box/doppe-action-widget-text-box';
import {DoppeViewerFormField} from '../../doppe-viewer-form-field/doppe-viewer-form-field';
import {useDoppeViewerLocales} from "../../../client/doppe-viewer-locales/doppe-viewer-locales";

export const DummyAddressElement = reactCreateMemo((props: {
    onLoaderStart?: () => void ,
    collectPhone?: boolean,
}) => {

    const {onLoaderStart, collectPhone} = props;

    React.useEffect(() => {
        onLoaderStart?.();
    }, [onLoaderStart]);

    const doppeViewerLocales = useDoppeViewerLocales();

    return (
        <div className={classes.root}>
            <DoppeViewerFormField
                label={doppeViewerLocales['fullName']}
            >
                <DoppeActionWidgetTextBox
                    className={style(classes.input, {})}
                    hasError={false}
                    shouldValidateValue={false}
                    placeholder={doppeViewerLocales['fullNamePlaceholder']}
                />
            </DoppeViewerFormField>
            <DoppeViewerFormField
                label={doppeViewerLocales['cardCountry']}
            >
                <DoppeActionWidgetTextBox
                    className={style(classes.input, {})}
                    hasError={false}
                    shouldValidateValue={false}
                    placeholder={doppeViewerLocales['cardCountry']}
                    suffixContent={
                        <Icon
                            className={style(classes.chevronIcon, {})}
                            icon={IconChevronDown}
                        />
                    }
                />
            </DoppeViewerFormField>
            <DoppeViewerFormField
                label={doppeViewerLocales['checkoutAddressLine']}
            >
                <DoppeActionWidgetTextBox
                    className={style(classes.input, {})}
                    hasError={false}
                    shouldValidateValue={false}
                    placeholder={doppeViewerLocales['checkoutAddressStreetAddress']}
                />
            </DoppeViewerFormField>
            {
                collectPhone ?
                    <DoppeViewerFormField
                        label={doppeViewerLocales['checkoutPhone']}
                    >
                        <DoppeActionWidgetTextBox
                            className={style(classes.input, {})}
                            hasError={false}
                            shouldValidateValue={false}
                            placeholder={doppeViewerLocales['checkoutPhone']}
                        />
                    </DoppeViewerFormField>
                    :
                    null
            }
        </div>
    );
});